module.exports = __webpack_public_path__ + "assets/img/logo.d94d0b50.png";